import { gql } from '@apollo/client';

export const getAdmin = gql`query getAdmin($referenceId: String!, $referenceType: String!, $isEncrypted: Boolean!) {
  admin {
      assignedAdminByReference(
          referenceId: $referenceId
          referenceType: $referenceType
          isEncrypted: $isEncrypted
      ) {
          id
          avatar
          name
          email
          phone
          phoneExt
          signature
          emailName
      }
  }
}`
